/**
 * Factory: notice
 *
 * Provides extended functionality
 * - Show messages
 * - Hide messages
 * - Show errors
 * - Hide errors
 * - Loading flags
 */
angular.module('acme.common.factory.notice', [
  'angular-growl',
  'angularUUID2',
])
.factory('NoticeFactory', [
  '$timeout',
  'uuid2',
  'growl',
  'growlMessages',
  '$q',
  function NoticeFactory(
    $timeout,
    uuid2,
    growl,
    growlMessages,
    $q
  ) {

  function Notice() {}

  Notice.prototype = {

    constructor: Notice,

    isLoaded: false,
    isLoading: false,

    isRefreshed: false,
    isRefreshing: false,

    showErrors: false,
    showSuccess: false,

    errors: [],
    messages: [],

    growlErrorMessages: [],
    growlSuccessMessages: [],

    init: function() {
      var self = this;
      self.isLoaded = false;
      self.isLoading = false;
      self.isRefreshed = false;
      self.isRefreshing = false;
      self.showErrors = false;
      self.showSuccess = false;

      self.errors = [];
      self.messages = [];
    },

    hideMessages: function() {
      var self = this;
      self.hideErrorMessages();
      self.hideSuccessMessages();
    },

    /**
     * 
     * @param {Array<any>} errors
     * @param {?{ duration?: number; }} options 
     */
    showErrorMessages: function(errors, options) {
      var self = this;
      var q = $q.defer();
      options = options || {};

      self.showErrors = true;

      if (errors && Array.isArray(errors)) {
        // replace null message with something meaningful
        self.errors = errors.map(function(error){
          if (!error.message) {
            error.message = 'Something went wrong, please try again in a few minutes.';
          }

          return error;
        });

        $timeout(function() {
          if (options.scrollToTop !== false) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }

          self.showGrowlErrorMessages(self.errors);

          if (options.duration) {
            $timeout(function() {
              self.hideErrorMessages();
              q.resolve();
            }, options.duration);
          } else {
            q.resolve();
          }
        }, 100);
      } else {
        q.resolve();
      }

      return q.promise;
    },

    hideErrorMessages: function() {
      var self = this;
      self.showErrors = false;
      self.errors = [];
      self.hideGrowlErrorMessages();
    },

    showGrowlErrorMessages: function(errors) {
      var self = this;
      var m, i, ii;
      var countMessage = '';
      var hooks = self.getExternalGrowlErrorHooks();

      for (i=0,ii=errors.length;i<ii;i++) {
        if (errors[i].hasOwnProperty('message')) {
          if (hooks.count && /^Please correct.*?errors below\.?/i.test(errors[i].message)) {
            countMessage = hooks.message;
          }
          m = growl.error(errors[i].message + countMessage);
          if (m) {
            self.growlErrorMessages.push(m);
          }
        }
      }
    },

    getExternalGrowlErrorHooks: function() {

      var uuid = uuid2.newuuid();
      var message;
      var errorFields = $('.generic-input-error');
      var current = 1;
      var count = errorFields.length;

      $(document).off('Errors::Next');
      $(document).off('Errors::Prev');

      $(document).on('Errors::Next', function(e, id) {
        e.stopPropagation();
        e.preventDefault();
        errorFields = $('.generic-input-error');
        count = errorFields.length;
        if (current > count) {
          current = 1;
        }
        $('#' + id + ' .growl-notice-count').text(current + ' of ' + count);
        $(errorFields.get(current - 1)).find('input, select').focus();
        current++;
      });

      $(document).on('Errors::Prev', function(e, id) {
        e.stopPropagation();
        e.preventDefault();
        errorFields = $('.generic-input-error');
        count = errorFields.length;
        current -= 2;
        if (current < 1) {
          current = count;
        }
        $('#' + id + ' .growl-notice-count').text(current + ' of ' + count);
        $(errorFields.get(current - 1)).find('input, select').focus();
        current++;
      });

      current = 1;
      message = '<div onclick="event.preventDefault();event.stopPropagation();" id="' + uuid + '"><a onclick="event.preventDefault();event.stopPropagation();$(document).trigger(\'Errors::Prev\', \'' + uuid + '\')" class="growl-notice-btn btn btn-link fa fa-caret-left"></a> <span class="growl-notice-count">' + current + ' of ' + count + '</span> <a onclick="event.preventDefault();event.stopPropagation();$(document).trigger(\'Errors::Next\',\'' + uuid + '\')" class="growl-notice-btn btn btn-link fa fa-caret-right"></a> issues found</div>';
      $(errorFields.get(current - 1)).find('input, select').focus();
      current++;

      return {
        message: message,
        current: current,
        count: count
      };

    },

    hideGrowlErrorMessages: function() {
      var self = this;
      var i, ii;

      for (i=0,ii=self.growlErrorMessages.length;i<ii;i++) {
        if (self.growlErrorMessages[i] && (typeof self.growlErrorMessages[i].destroy === 'function')) {
          self.growlErrorMessages[i].destroy();
        }
      }
      self.growlErrorMessages = [];
    },

    /**
     * 
     * @param {Array<any>} messages
     * @param {{ duration?: number; }} options 
     */
    showSuccessMessages: function(messages, options) {
      var self = this;
      var q = $q.defer();
      options = options || {};

      self.showSuccess = true;

      if (messages && Array.isArray(messages)) {
        self.messages = messages;

        $timeout(function() {
          self.showGrowlSuccessMessages(self.messages);
  
          if (options.duration) {
            $timeout(function() {
              self.hideSuccessMessages();
              q.resolve();
            }, options.duration);
          } else {
            q.resolve();
          }
        }, 100);
      } else {
        q.resolve();
      }

      return q.promise;
    },

    hideSuccessMessages: function() {
      var self = this;
      self.showSuccess = false;
      self.messages = [];
      self.hideGrowlSuccessMessages();
    },

    showGrowlSuccessMessages: function(messages) {
      var self = this;
      var m, i, ii;

      for (i=0,ii=messages.length;i<ii;i++) {
        if (messages[i].hasOwnProperty('message')) {
          m = growl.success(messages[i].message);
          self.growlSuccessMessages.push(m);
        }
      }
    },

    hideGrowlSuccessMessages: function() {
      var self = this;
      var i, ii;

      for (i=0,ii=self.growlSuccessMessages.length;i<ii;i++) {
        if (self.growlSuccessMessages[i]) {
          self.growlSuccessMessages[i].destroy();
        }
      }
      self.growlSuccessMessages = [];
    },

    hideGrowlMessages: function(){
      growlMessages.destroyAllMessages();
    },

    startLoad: function() {
      var self = this;
      self.isLoaded = false;
      self.isLoading = true;
      self.hideSuccessMessages();
      self.hideErrorMessages();
    },

    endLoad: function() {
      var self = this;
      self.isLoaded = true;
      self.isLoading = false;
    },

    startRefresh: function() {
      var self = this;
      self.isRefreshed = false;
      self.isRefreshing = true;
    },

    endRefresh: function() {
      var self = this;
      self.isRefreshed = true;
      self.isRefreshing = false;
    }

  };

  return Notice;

}]);